<div class="flex justify-end items-center">
  <a
    *ngIf="sourceData | containsSource: type as source"
    class="sources {{ type }}-source link-muted flex items-center gap-1"
    [href]="sourceDataHelpArticle"
    target="_blank">
    <sbnb-icon class="hover-icon" [size]="10" [icon]="sourceDataIcon"></sbnb-icon>
    <span
      #tooltipRef="matTooltip"
      [sbnbThrottleTooltip]="tooltipRef"
      [matTooltip]="source | friendlySourceTooltip"
      [matTooltipPosition]="tooltipPosition"
      data-tooltip-source-label>
      source: {{ source.source | friendlySourceLabel }}
    </span>
  </a>
</div>
